import { atom, useAtom } from "jotai";
import { State } from "./State";
import { fetchBase } from "./BaseApi";

type PasswordConfirm = {
  email: string;
};

type PasswordConfirmParam = {
  token: string;
};

const uri = "api/password-verify";

export const fetchPasswordConfirmAtom = atom<State<PasswordConfirm> | null>(null);
export const fetchPasswordConfirm = () => {
  return fetchBase<PasswordConfirm, PasswordConfirmParam>(uri, fetchPasswordConfirmAtom);
};
